import Cookies from 'js-cookie';
import { getMsUntilAccessExpiry } from '../config/authSession';
import { performSilentSessionRefresh } from '../config/dataService/dataService';

const HOURLY_INTERVAL_MS = 60 * 60 * 1000;
const MIN_INTERVAL_MS = 60 * 1000;
const ACCESS_EXPIRY_BUFFER_MS = 2 * 60 * 1000;

/**
 * access_expires_at veya expires_in'e göre yenileme aralığı.
 * En fazla saatte bir; access süresi daha kısaysa dolmadan önce yeniler.
 */
function computeIntervalMs(accessExpiresInSeconds) {
  let msUntilExpiry = getMsUntilAccessExpiry();

  if (msUntilExpiry === null && typeof accessExpiresInSeconds === 'number' && accessExpiresInSeconds > 0) {
    msUntilExpiry = accessExpiresInSeconds * 1000;
  }

  if (msUntilExpiry !== null) {
    const beforeExpiry = Math.max(MIN_INTERVAL_MS, msUntilExpiry - ACCESS_EXPIRY_BUFFER_MS);
    return Math.min(HOURLY_INTERVAL_MS, beforeExpiry);
  }

  return HOURLY_INTERVAL_MS;
}

let refreshIntervalId = null;
let refreshInProgress = false;

function stop() {
  if (refreshIntervalId !== null) {
    clearInterval(refreshIntervalId);
    refreshIntervalId = null;
  }
}

async function performRefresh() {
  if (refreshInProgress) {
    return;
  }
  refreshInProgress = true;
  try {
    const result = await performSilentSessionRefresh();
    if (!result.ok) {
      stop();
      return;
    }

    const nextIntervalMs = computeIntervalMs();
    stop();
    refreshIntervalId = setInterval(performRefresh, nextIntervalMs);
  } finally {
    refreshInProgress = false;
  }
}

/**
 * Proaktif oturum yenileme: "Oturumu açık tut" işaretli kullanıcılar için
 * saatte bir (veya access süresi dolmadan önce) /v1/auth/refresh çağrılır.
 */
function start(accessExpiresInSeconds) {
  stop();

  const isLoggedIn = Cookies.get('logedIn');
  const rememberMe = Cookies.get('remember_me');

  if (!isLoggedIn || !rememberMe) {
    return;
  }

  const intervalMs = computeIntervalMs(accessExpiresInSeconds);
  const msUntilExpiry = getMsUntilAccessExpiry();

  if (msUntilExpiry !== null && msUntilExpiry <= ACCESS_EXPIRY_BUFFER_MS) {
    performRefresh();
  }

  refreshIntervalId = setInterval(performRefresh, intervalMs);
}

export default { start, stop };
